import * as S from '../ConvenienceTest.style';
import ConvenienceTestFinanceInputs from './ConvenienceTestFinanceInputs';
import { useHistory, useParams } from 'react-router-dom';
import UserIdentitiesService, { UserIdentityType } from '../../../services/UserIdentitiesService';
import { useCallback, useContext, useEffect, useState } from 'react';
import { DefaultButton, Spinner, SpinnerSize } from '@fluentui/react';
import scrollToTop from '../../../utils/scrollToTop';
import React from 'react';
import SavingsPlanService, { SavingsPlanType } from '../../../services/SavingsPlanService';
import DocumentTitle from 'react-document-title';
import { ThemeContext } from '@fluentui/react-theme-provider';
import Auth from '../../../Auth/Auth';
import UserService from '../../../services/UserService';
import { UserIndentityStatusEnum } from '../../types/UserIdentity.Status';

const ConvenienceTestFinance = () => {
    const history = useHistory();
    const user = Auth.getUserProfile();
    const savingsPlanId = 1208;
    const userIdentityId = 15;
    const theme = useContext(ThemeContext);
    const [error, setError] = useState({ message: '' });
    const [userIdentity, setUserIdentity] = useState<UserIdentityType>();
    const [savingsPlan, setSavingsPlan] = useState<SavingsPlanType>();
    const [canSubmit, setCanSubmit] = useState(false);
    const [userIdentityForm, setUserIdentityForm] = useState<any>();
    const [sending, setSending] = useState(false);

    const [amlVerificationSuccess, setAMLVerificationSuccess] = useState<boolean>(true);

    useEffect(() => {
        scrollToTop();
    }, []);

    useEffect(() => {
        if (userIdentityId !== null && userIdentityId !== undefined) {
            UserIdentitiesService.getUserIdentity(userIdentityId).then((userIdentity: UserIdentityType) => {
                setUserIdentityForm(
                    {
                        economicActivity: false,
                        proofOfIncome: false,
                        gafiQuestion: false,
                        publicPosition: false
                    });

                setUserIdentity(userIdentity);
            },
                (error) => {
                    setError(error);
                });
        }
    }, [userIdentityId]);

    useEffect(() => {
        SavingsPlanService.getSavingsPlan(savingsPlanId).then((savingsPlan: any) => {
            setSavingsPlan(savingsPlan);
        },
            (error: any) => {
                setError(error);
            })
    }, [savingsPlanId]);

    const handleFinanceChange = (event: any) => {
        var { name, value }: { name: string, value: any } = event.target;
        var realValue = value;
        if (event.target.files !== undefined && event.target.files !== null && event.target.files.length) {
            realValue = event.target.files[0];
        }
        else {
            if (['gafiQuestion', 'publicPosition'].includes(name)) {
                realValue = value === "true";
            }
        }
        setUserIdentity((prevState: any) =>
        ({
            ...prevState,
            [name]: realValue
        }
        ));
    };

    const btnSubmit = useCallback(() => {
        if (userIdentityForm !== undefined) {
            setCanSubmit(Object.values(userIdentityForm).every((x) => x === true));
        }
    }, [userIdentityForm]);

    useEffect(() => {
        btnSubmit();
    }, [btnSubmit, userIdentity]);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (userIdentity !== undefined) {
            setSending(true);
            try {
                if (user.status === "4000") {
                    userIdentity.status = UserIndentityStatusEnum.Active;
                }
                const updateResponse = await UserIdentitiesService.updateUserIdentity(userIdentity) as UserIdentityType;
                if (updateResponse.id! && updateResponse.id !== undefined) {
                    const amlVerificationResponse = await UserIdentitiesService.AMLVerification(userIdentity.id!, userIdentity.idDocument!);
                    if (amlVerificationResponse.status === 200) {
                        setAMLVerificationSuccess(true);
                        if (savingsPlan !== undefined) {
                            // Si el usuario tiene estado 4000 (nuevo usuario de la webPública), cambiamos al Status = 1001
                            if (user.status === "4000") {
                                try {
                                    const newStatus = "1001";
                                    const updatedUser = await UserService.setUserStatus(user.id, newStatus);
                                    // Verifica el estado del usuario actualizado
                                    if (updatedUser) { 
                                        history.push('/accountHolder/' + savingsPlan.id);
                                    } else {
                                        setError({ message: 'No se pudo cambiar el estado del usuario.' });
                                    }
                                } catch (error) {
                                    console.error('Error al cambiar el estado del usuario:', error);
                                    setError({ message: 'Error al cambiar el estado del usuario' });
                                }
                            }

                            history.push('/accountHolder/' + savingsPlan.id);
                        }
                    } else {
                        setError({ message: amlVerificationResponse?.data?.message || 'Error desconocido' });
                        setAMLVerificationSuccess(false);
                    }
                } else {
                    setAMLVerificationSuccess(false);
                    setError({ message: 'Error actualizando la identidad del usuario' });
                }
            } catch (error: any) {
                setError({ message: error.response?.data?.message || error.message || 'Error desconocido' });
                setAMLVerificationSuccess(false);
            } finally {
                setSending(false);
            }
        }
    };

    return (
         <>
            <div className="financial-form-container">
                
            </div>
            </>
        // <DocumentTitle title={`IronIA - Documentación Financiera`}>
        //     <React.Fragment>
        //         <S.HelperStyle />
        //         <S.Cont theme={theme}>
        //                 {userIdentity === undefined &&
        //                     (
        //                         <Spinner size={SpinnerSize.large} />
        //                     )}
        //                 {userIdentity !== undefined &&
        //                     (
        //                         <>
        //                         <S.SubTitle>
        //                                 Actividad económica y Justificante de ingresos del
        //                                 <span> Interviniente - {[userIdentity.firstName, userIdentity.lastName, userIdentity.secondLastName].join(" ")}</span>
        //                             </S.SubTitle>
        //                             <S.Phrase>
        //                                 Necesitamos un justificante que acredite el origen de su patrimonio, para
        //                                 ello sirve la declaración de la renta, una nómina, justificante de venta de
        //                                 inmueble, etc.
        //                             </S.Phrase>
        //                             <ConvenienceTestFinanceInputs data={userIdentity}
        //                                 handleChange={(event: any) => handleFinanceChange(event)}
        //                                 formVal={userIdentityForm}
        //                                 setFormVal={(name: string, value: any) => setUserIdentityForm((prevState: any) => ({ ...prevState, [name]: value }))}
        //                             />
        //                         </>
        //                     )}
        //                 {/* <S.BtnCont>
        //                     {error.message !== "" && (
        //                         <S.TabletCont theme={theme}>
        //                             <S.Error>{error.message}</S.Error>
        //                         </S.TabletCont>
        //                     )}

        //                     {!amlVerificationSuccess ? (
        //                         <DefaultButton
        //                             onClick={() => history.push('/accountHolder/' + savingsPlanId)}
        //                             className="button tiny-secondary-button"
        //                         >
        //                             Cancelar
        //                         </DefaultButton>
        //                     ) : (
        //                         <>
        //                             <DefaultButton
        //                                 disabled={userIdentity === undefined}
        //                                 onClick={() => history.push('/accountHolderData/' + savingsPlanId + '/' + userIdentityId)}
        //                                 className="button tiny-secondary-button"
        //                             >
        //                                 Volver
        //                             </DefaultButton>
        //                             <DefaultButton
        //                                 onClick={(event) => handleSubmit(event)}
        //                                 disabled={userIdentity === undefined || !canSubmit || sending || error.message !== ""}
        //                                 className="button tiny-primary-button"
        //                             >
        //                                 {sending && <Spinner size={SpinnerSize.small} className="button-spinner" />}
        //                                 Continuar
        //                             </DefaultButton>
        //                         </>
        //                     )}
        //                 </S.BtnCont> */}
        //         </S.Cont>
        //     </React.Fragment>
        // </DocumentTitle>
    );
};

export default ConvenienceTestFinance;